import { render } from "./InactivityModal.vue?vue&type=template&id=5b93746c&scoped=true"
import script from "./InactivityModal.vue?vue&type=script&lang=js"
export * from "./InactivityModal.vue?vue&type=script&lang=js"

import "./InactivityModal.vue?vue&type=style&index=0&id=5b93746c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b93746c"]])

export default __exports__